import Table from "@material-ui/core/Table"
import React, { useEffect, useState } from "react";
import store from "src/store";
import moment from "moment";
//@ts-ignore
import { Link } from 'react-router-dom'
import { SCR_APP_URLS } from "shared/consts";
import { getSimulationURL } from "src/utils/get-simulation-library-url";
import { TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import MyTable from "./MyTable";

export default function AnalyticsTable() {

    const [analyticsTableData, setAnalyticsTableData] = useState([]);

    const columns = [
        {
            name: 'created',
            label: 'Date',
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div>{moment(value).format("MM-DD-YYYY | hh:mm A")}</div>;
                },
            },
        },
        {
            name: 'organization',
            label: 'Organization',
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div>
                        {value.link ? <Link to={value.link}>{value.name}</Link> : value.name}
                    </div>;
                },
            },
        },
        {
            name: 'engagement',
            label: 'Engagement',
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div>
                        {value.link ? <Link to={value.link}>{value.name}</Link> : value.name}
                    </div>;
                },
            },
        },
        {
            name: 'review',
            label: 'Review',
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div>
                        {value.link ? <Link to={value.link}>{value.name}</Link> : value.name}
                    </div>;
                },
            },
        },
        {
            name: 'user',
            label: 'User',
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div>
                        {value.api_key ? <span>{value.email} {'(' + value.api_key + ')'} </span> : value.email}
                    </div>;
                },
            },
        },
        {
            name: 'operation',
            label: 'Operation'
        },
        {
            name: 'simulation',
            label: 'Simulation',
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div>
                        {value.link ? <Link to={value.link}>{value.name}</Link> : value.name}
                    </div>;
                },
            },
        }
    ];

    useEffect(() => {
        createAnalyticsData();
    }, [store.analytics]);

    const createAnalyticsData = () => {
        if (store.analytics.length) {
            let analyticsTableData = store.analytics.map((item) => {
                return {
                    created: item.created,
                    organization: {
                        name: item['organizationData'] ? item.organizationData.name : 'N/A',
                        link: item['organizationData'] ? SCR_APP_URLS.organizationManager : null
                    },
                    engagement: {
                        name: item.engagement_name == "Private" ? item.engagementData.engId : item.engagement_name,
                        link: item.engagement_id ? SCR_APP_URLS.engagementManager : null
                    },
                    review: {
                        name: item.review_name,
                        link: item.review_id ? SCR_APP_URLS.myReview : null
                    },
                    user: {
                        email: item.user_email,
                        api_key: item.api_key
                    },
                    operation: item.operation,
                    simulation: {
                        name: item.simulation_name,
                        link:
                            item.simulation_id ?
                                item.review_id ?
                                    getSimulationURL({ simulationId: item.simulation_id }) + '?engagement_id=' + item.engagement_id + '&review_id=' + item.review_id
                                    : getSimulationURL({ simulationId: item.simulation_id })
                                : null
                    }
                }
            });
            setAnalyticsTableData(analyticsTableData);
        }
    }

    return <MyTable
        columns={columns}
        data={analyticsTableData}
    />
}